import type { BranchEntity } from '@/features/branch/domain/entities/BranchEntity'
import type { JobStatus } from '../enums/JobStatus'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class JobMiniEntity {
  id?: string
  branch?: BranchEntity
  driver?: DriverEntity
  status?: JobStatus
  shipmentsCount?: number
  regionId?: number
  regionName?: string
  inRearrangement?: boolean
  createdAt?: string
  statusSetOn?: string
}
